import { apiClient } from '@packages/api-client';

// 总览统计数据接口
export interface OverviewStatisticsVo {
  countPublishedOntology: number;
  countOntologyObjects: number;
}

// 统计API类
export class StatisticsApi {
  /**
   * 获取总览页面统计数据
   * @returns 总览统计数据
   */
  static async getOverviewStatistics(): Promise<OverviewStatisticsVo> {
    try {
      console.log('🚀 获取总览统计数据');
      
      const response = await apiClient.get<OverviewStatisticsVo>('/ontology_statistics/overview');
      
      console.log('📨 总览统计数据响应:', response);
      
      return response.data;
    } catch (error: any) {
      console.error('❌ 获取总览统计数据失败:', error);
      throw error;
    }
  }
}